import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue, FctValue16 } from '../../../../Fct/generics';
import { getAaveV3Tokens } from '../../allowanceRequiredProtocols';
import { A_TOKENS, POOL_ADDRESSES } from '../constants';
export var Borrow = createPlugin({
    protocol: 'AaveV3',
    type: 'ACTION',
    method: 'borrow',
    supportedContracts: POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_pool_v3' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getAaveV3Tokens({ chainId: chainId }) }),
                    amount: new FctValue({ destination: 'wei_amount' }),
                    interestRateMode: new FctValue({ options: [{ value: '1', name: 'stable' }, { value: '2', name: 'variable' }] }),
                    referralCode: new FctValue16({ required: false, readonly: true }),
                    onBehalfOf: new FctAddress({}),
                },
            },
            output: {},
        });
    },
    initParams: {
        methodParams: {
            referralCode: '0', // Aave has disabled referral codes, 0 by default
        },
    },
    requiredApprovals: function (params, chainId, _walletAddress, vaultAddress, _p, _m, isEstimation) {
        var _a = params.methodParams, amount = _a.amount, onBehalfOf = _a.onBehalfOf, asset = _a.asset;
        var assetValue = asset.value;
        if (assetValue && typeof assetValue != 'string') {
            return [];
        }
        var fromTokenData = A_TOKENS[chainId].find(function (token) { return token.underlyingAssetAddress.toLowerCase() === assetValue.toLowerCase(); });
        if (!fromTokenData) {
            return [];
        }
        if (!vaultAddress)
            return [];
        var value = amount.value;
        if (isEstimation && typeof amount.estimatedValue === 'string') {
            value = amount.estimatedValue;
        }
        if (!value)
            return [];
        return [
            {
                to: fromTokenData.aTokenAddress,
                from: onBehalfOf.value,
                params: { delegatee: vaultAddress, amount: value },
                method: 'approveDelegation',
                protocol: 'AAVE',
            },
        ];
    },
    assetFlow: function (params, chainId, _walletAddress, vaultAddress) {
        var to = params.to, _a = params.methodParams, amount = _a.amount, asset = _a.asset, onBehalfOf = _a.onBehalfOf, interestRateMode = _a.interestRateMode;
        if (!interestRateMode.value || !asset.value || !to.value || !amount.value || !onBehalfOf.value || !vaultAddress)
            return [];
        if (typeof interestRateMode.value !== 'string' ||
            typeof amount.value !== 'string' ||
            typeof asset.value !== 'string' ||
            typeof to.value !== 'string')
            return [];
        var assetData = A_TOKENS[chainId].find(function (token) { return token.underlyingAssetAddress.toLowerCase() === asset.value.toLowerCase(); });
        if (!assetData)
            return [];
        var debtToken = interestRateMode.value === '1' ? assetData.stableDebtTokenAddress : assetData.variableDebtTokenAddress;
        return [
            {
                address: vaultAddress,
                toSpend: [],
                toReceive: [
                    {
                        token: asset.value,
                        amount: amount.value,
                    },
                    {
                        token: debtToken,
                        amount: amount.value,
                    },
                ],
            },
            {
                address: to.value,
                toSpend: [
                    {
                        token: asset.value,
                        amount: amount.value,
                    },
                ],
                toReceive: [],
            },
        ];
    },
});
